import { ref } from 'vue';
import { ProductClientService, ProductSpotModel } from '@/types/productServerApi';

export default function useProductComposingOverlay() {
    const shouldShowConfigurationModulesDialog = ref(false);
    const pending = ref<boolean>(false);
    const productComposingModules = ref<ProductSpotModel[]>();

    function showComposingModules(sku: string, configurationId?: string) {
        shouldShowConfigurationModulesDialog.value = true;
        loadConfiguraiton(sku, configurationId);
    }

    function closeComposingModules() {
        shouldShowConfigurationModulesDialog.value = false;
    }

    async function loadConfiguraiton(sku: string, configurationId?: string) {
        try {
            pending.value = true;
            const response = await ProductClientService.getComposingModules(sku, configurationId);
            productComposingModules.value = response.model;
        } catch (error) {
            productComposingModules.value = undefined;
        } finally {
            pending.value = false;
        }
    }

    return {
        shouldShowConfigurationModulesDialog,
        productComposingModules,
        showComposingModules,
        closeComposingModules,
    };
}
